var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAltronicWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 244.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "final"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.78,198V5H301.4V226.08H450.83V198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.33,5V33.17h64.55V226.08h31.38V33.17h64.23V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M914.88,132.36c28.54-8.21,45.7-30.32,45.7-62.12C960.58,30.33,932.05,5,887.4,5H798.63V226.08H830V135.84H881.4l56.33,90.24h35.7ZM830,107.72V33.49l57.81-.32c27.06,0,41.38,12.85,41.38,37.07s-14.32,37.48-41.38,37.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177.4,0c-68.13,0-114.78,53.49-114.78,114.88,0,65.61,49.17,116.26,114.14,116.26s114.78-50.65,114.78-116.26C1291.54,53.49,1245.53,0,1177.4,0Zm0,202.91c-48.86,0-83.4-36.75-83.4-88,0-50.65,33.91-86.76,82.76-86.76,49.18,0,83.4,36.43,83.4,86.76C1260.16,166.59,1226.26,202.91,1177.4,202.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1535.5,5V168.35l-38.64-56.23-18.56-27L1423.17,5h-25V226.1H1428l.3-.43h1.28V62.73L1542,226.1h25V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1685.36,5V226.08h31.38V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1937.24,28.12c28.12,0,48.44,8.21,62.76,23.9v-35C1981.78,5.69,1960.72,0,1938,0c-68.13,0-114.88,53.49-114.88,114.88,0,65.61,49.59,116.26,114.14,116.26a118.54,118.54,0,0,0,62.76-17.8v-35c-13.9,16-34.64,24.53-62,24.53-49,0-83.5-36.75-83.5-88C1854.48,64.23,1888.38,28.12,1937.24,28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.44,226.07H168.32l-27.83-61.28-13.25-28.52L88,46.06,66.58,95.47,48.19,137.61c-.54,1.19-1.1,2.35-1.67,3.55l-.65,1.45h-.18l-6.91,15.33,7.09-15.33H100S.06,244.41,0,244.41l38.49-85.78-2.71,5.8-.18.36-2.09,4.58H1.43l2.38-5.27c4.43-9.58,8.84-19.34,13.25-29.17S26,115.29,30.36,105.5c.24-.6.6-1.28.92-1.94.9-2,2-4.28,2.74-6.1A3.49,3.49,0,0,1,34.2,97a2.62,2.62,0,0,1,.3-.53L76,5H99.47s64.95,142.19,90.64,198.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltronicWordmarkWhite);
export default __webpack_public_path__ + "static/media/altronic-wordmark-white.1ff65ca119ec42f818d097b7eacc908b.svg";
export { ForwardRef as ReactComponent };